// extracted by mini-css-extract-plugin
export default {"recos":"w3-z","productCardOverride":"x3-z","rowHasBadge":"y3-z"};